/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetAgentSessionMetaSecurity = {
  apikeyHeaderGramKey?: string | undefined;
};

export type GetAgentSessionMetaRequest = {
  /**
   * Native harness session identifiers (e.g. Claude Code session UUIDs, Codex rollout ids) to resolve. Speakeasy derives its chat ids from these the same way hook ingest does.
   */
  sessionIds: Array<string>;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type GetAgentSessionMetaSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const GetAgentSessionMetaSecurity$outboundSchema: z.ZodMiniType<
  GetAgentSessionMetaSecurity$Outbound,
  GetAgentSessionMetaSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function getAgentSessionMetaSecurityToJSON(
  getAgentSessionMetaSecurity: GetAgentSessionMetaSecurity,
): string {
  return JSON.stringify(
    GetAgentSessionMetaSecurity$outboundSchema.parse(
      getAgentSessionMetaSecurity,
    ),
  );
}

/** @internal */
export type GetAgentSessionMetaRequest$Outbound = {
  session_ids: Array<string>;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const GetAgentSessionMetaRequest$outboundSchema: z.ZodMiniType<
  GetAgentSessionMetaRequest$Outbound,
  GetAgentSessionMetaRequest
> = z.pipe(
  z.object({
    sessionIds: z.array(z.string()),
    gramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionIds: "session_ids",
      gramKey: "Gram-Key",
    });
  }),
);

export function getAgentSessionMetaRequestToJSON(
  getAgentSessionMetaRequest: GetAgentSessionMetaRequest,
): string {
  return JSON.stringify(
    GetAgentSessionMetaRequest$outboundSchema.parse(getAgentSessionMetaRequest),
  );
}
